//confirm window
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

function Modal(props) {
    const { t } = useTranslation("translation");

    return (
        <div>
            <Dialog id="Delete_Dialog" open={props.isModalOpen} onClose={props.toggle} aria-labelledby="responsive-dialog-title">
                <DialogTitle id="responsive-dialog-title">{props.title}</DialogTitle>
                <DialogContent id="Delete_Content">
                    <DialogContentText>{props.content}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button id="Delete_Confirm" autoFocus onClick={props.approved} color="primary">
                        {t("Confirm")}
                    </Button>
                    <Button id="Delete_Cancel" onClick={props.toggle} color="primary" autoFocus>
                        {t("Cancel")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Modal;
